module.exports = new __parcel__URL__("Acadia Picture.7017179b.jpg").toString();